function adjustPanelsHeight() {
    const panelsContainer = document.querySelector('.panels');
    const currentPanel = document.querySelector('.panel.movingIn'); // or however you identify the current panel

    if (panelsContainer && currentPanel) {
        // Get the current panel's full height (including dynamic content)
        const panelHeight = currentPanel.scrollHeight;

        // Apply the height to the parent container
        panelsContainer.style.height = panelHeight + 'px';
    }
}

// Call this function whenever the panel content changes
// Example: after showing/hiding the "Others" field
document.addEventListener('change', function(e) {
    if (e.target.matches('.panel input, .panel select, .panel textarea')) {
        adjustPanelsHeight();
    }
});

console.log("SCROLL CHECK");

// Attach to Next and Previous buttons
document.addEventListener('globo.formbuilder.step.move', function(e) {
    console.log('CUSTOM EVENT TRIGGERED', e);
    setTimeout(() => {
        const heading = document.querySelector('.title.globo-heading');
        if (heading) {
            console.log("SCROLL TO HEADING");
            heading.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, 100); // adjust delay as needed
});




var carousel = document.querySelector('.other-products');
var flkty = new Flickity(carousel, {
  prevNextButtons: false,
  pageDots: false
});

// previous
var previousButton = document.querySelector('.button--previous');
if (previousButton) {
  previousButton.addEventListener('click', function() {
    flkty.previous();
  });
}

// next
var nextButton = document.querySelector('.button--next');
if (nextButton) {
  nextButton.addEventListener('click', function() {
    flkty.next();
  });
}
